module.exports = __webpack_public_path__ + "img/Checkbox-Hover-icon-add blue.c233814d.svg";